module.exports = __webpack_public_path__ + "static/media/hannes-egler-unsplash-2000.98368c1f.jpg";